import React, { Component } from 'react'
import { isEmpty } from "lodash"

class PageLoader extends Component {
    constructor(props) {
        super(props)
    }
    render() {
        let { loaderMsg } = this.props
        if (isEmpty(loaderMsg))
            loaderMsg = "Loading... wait...";
        return (
            <div className="loader-container">
                <div className="loader">
                    <div className="loader-content">
                        <div
                            className="spinner-grow text-primary m-1"
                            role="status"
                        >
                            <span className="sr-only">{loaderMsg}</span>
                        </div>
                        <div
                            className="spinner-grow text-primary m-1"
                            role="status"
                        >
                            <span className="sr-only">{loaderMsg}</span>
                        </div>
                        <div
                            className="spinner-grow text-primary m-1"
                            role="status"
                        >
                            <span className="sr-only">{loaderMsg}</span>
                        </div>
                    </div>
                    <div className="loader-text text-muted font-size-14 mt-2">
                        <span>{loaderMsg}</span>
                    </div>
                </div>
            </div>
        )
    }
}

export default PageLoader;